import React, { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute, RoleGuard } from "@shared/components";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const CreateOperation = lazy(() => import("./pages/CreateOperation"));
const DetailOp = lazy(() => import("./pages/DetailOp"));
const DetailRow = lazy(() => import("./pages/DetailRow"));

/**
 * Route elements for the YTG module, spread into the app's top-level `<Routes>`.
 *
 * Covers the dashboard, the admin-only create-operation flow, and the operation
 * and row detail views. Every route is wrapped in `ProtectedRoute`; the
 * create-operation route additionally requires the `admin` or `tm` role.
 */
export const ytgRoutes = [
    <Route key="ytg-dashboard" path="/ytg" element={<ProtectedRoute><Dashboard/></ProtectedRoute>}/>,
    // /ytg/create-operation is a write-only flow — restricted to admin+tm
    // (mirrors gateway RBAC commit 56c3423). user/viewer get redirected
    // to the YTG dashboard by RoleGuard's default fallback.
    <Route key="ytg-create" path="/ytg/create-operation" element={<ProtectedRoute><RoleGuard requiredRoles={["admin", "tm"]}><CreateOperation/></RoleGuard></ProtectedRoute>}/>,
    <Route key="ytg-op" path="/ytg/operation/:id" element={<ProtectedRoute><DetailOp/></ProtectedRoute>}/>,
    <Route key="ytg-row" path="/ytg/operation/:operationId/row/:rowId" element={<ProtectedRoute><DetailRow/></ProtectedRoute>}/>,
];
